import SobreNos from './sobreNos';
export default function Content({ handleClick, setSeverity, setMessage }) {
    return (
        <>
            <SobreNos />
        </>
    );
};